export default __webpack_public_path__ + "static/media/photo_mvs-noticias.575e832f.jpg";